/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Login.tsx
 * Project: mle-client
 * Committed last: 2021/10/25 @ 1138
 * ---
 */

import React, { useCallback, useState }           from 'react';
import { Button, Callout, Card, Divider, Intent } from '@blueprintjs/core';
import {
  LoginForm
}                                                 from '../components/forms/LoginForm';
import { useDispatch, useSelector }               from 'react-redux';
import { RootState }                              from '../store';
import {
  localLogin,
  LocalLoginCredentials
}                                                 from '../store/actions/auth-actions';
import { Link }                                   from 'react-router-dom';
import { RootPaths }                              from '../paths/root.paths';

export const Login = (props: any) => {
  const authData = useSelector((state: RootState) => state.authState);
  const [authFailed, setAuthFailed] = useState(false);
  const dispatch = useDispatch();

  const onLoginSubmit = useCallback(async (values) => {
    const result = await dispatch(localLogin({
      ...values
    } as LocalLoginCredentials));

    const payload = (result as any).payload;
    if (payload === undefined) setAuthFailed(true);
    else setAuthFailed(false);
  }, [setAuthFailed]);

  return (
    <div className="mle-center-both-axes-parent">
      <div className="mle-center-both-axes-child w-96">
        <div className="mb-5">
          <Callout
            intent={ Intent.NONE }
            title="MVP"
          >
            <div className="font-normal">
              La versione attuale di MLEditor contiene esclusivamente
              le funzionalità chiave del prodotto e può essere utilizzata solo
              se abilitati da un operatore MyLabel.
            </div>
            <div className="font-normal mt-4">
              <a
                href="mailto:editor@mylabel.it?subject=Demo%20MLEditor"
                rel="noreferrer"
                target="_blank"
              >
                <Button intent={ Intent.PRIMARY } small>
                  Contattaci e richiedi una demo
                </Button>
              </a>
            </div>
          </Callout>
        </div>
        <Card className="font-semibold w-96">
          <h4 className="bp4-heading">MLEditor <div
            className="font-light">Accedi</div></h4>
          <Divider className="my-4"/>
          {
            authFailed &&
            <div className="font-normal my-2 text-red-200"> Nome utente o
              password errate. </div>
          }
          <Link to={ RootPaths.FORGOT_PASSWORD }>
            Ho dimenticato la password
          </Link>
          <LoginForm onSubmit={ onLoginSubmit }/>
        </Card>
      </div>
    </div>
  );
};
